// Manual Extensionf for Generated entities

import { IFDRW_Anordnungsblatt } from "./rwfpages.generated";
import { NavPageItem } from '@common/navdata';
import { FDRW_Anordnungsblatt } from './rwf.const';

 // Some Fields only in AT!
export interface IFDRW_Anordnungsblatt_AT extends IFDRW_Anordnungsblatt {
    FA_Posting_Type: string;
    Anlagennr: string;
}

export function IsATAO(item: NavPageItem): item is NavPageItem<IFDRW_Anordnungsblatt_AT> {
    return item?.PageName == FDRW_Anordnungsblatt &&
        !!(item as NavPageItem<IFDRW_Anordnungsblatt_AT>).MetaData.PropsByName["FA_Posting_Type"];
}
